import React from 'react'
import styled from 'styled-components'
import { ContentsSubInputText } from 'components/resume-analyzer/styles'
import { Column, Row } from 'components/common/layout'
import { TbBrandTwitterFilled, TbMessageCircleFilled } from 'react-icons/tb'
import { FiLink } from 'react-icons/fi'
import { HOST_BASE_URL } from 'infra/constants'
import { useRouter } from 'next/router'
import TagManager from 'react-gtm-module'
import { useInitializeKakaoShare } from 'utils/hooks'

const ICON_SIZE = 20

const handleCopy = async (url: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'share_link',
      clickText: '링크 복사 아이콘',
    },
  })
  await window.navigator.clipboard.writeText(url)
  alert('클립보드에 복사되었습니다.')
}

export const shareTwitter = (title: string, url: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'share_twt',
      clickText: '트위터 공유 아이콘',
    },
  })
  window.open(
    `https://twitter.com/intent/tweet?text=${title}&url=${url}`,
    '_blank',
  )
}

export const MarketingContentsShare: React.FC<{
  onClickKakao: () => void
  onClickTwitter: () => void
}> = ({ onClickKakao, onClickTwitter }) => {
  const router = useRouter()
  useInitializeKakaoShare()
  return (
    <Column style={{ alignItems: 'center', gap: 10 }}>
      <ContentsSubInputText>테스트 공유하기</ContentsSubInputText>
      <Row style={{ gap: 10 }}>
        <IconWrapper backgroundColor='#fee500' onClick={onClickKakao}>
          <TbMessageCircleFilled size={ICON_SIZE} color='#3B4248' />
        </IconWrapper>
        <IconWrapper backgroundColor='#7ccafa' onClick={onClickTwitter}>
          <TbBrandTwitterFilled size={ICON_SIZE} color='#FFFFFF' />
        </IconWrapper>
        <IconWrapper
          backgroundColor='#999999'
          onClick={() => handleCopy(`${HOST_BASE_URL}${router.asPath}`)}
        >
          <FiLink size={ICON_SIZE} color='#FFFFFF' />
        </IconWrapper>
      </Row>
    </Column>
  )
}

const IconWrapper = styled(Row)<{ backgroundColor: string }>`
  width: 30px;
  height: 30px;
  border-radius: 100px;
  justify-content: center;
  background-color: ${(p) => p.backgroundColor};
  cursor: pointer;
`
